module.exports = __webpack_public_path__ + "static/media/ru_02_offline.f1a06832.png";